<template>
  <el-dialog
    class="excellent-capabilities-call-test-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="data.title"
    top="25vh"
  >
    <el-form
      ref="inputForm"
      :model="data.formModel"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      :rules="data.formRules"
    >
      <template v-for="(item, index) in data.formItems">
        <template v-if="item.isArray">
          <el-form-item
            v-for="(cItem, cIndex) in data.formModel[item.prop]"
            :key="`${index}#${cIndex}`"
            :prop="item.prop"
            :label="`${item.label}${cIndex}`"
          >
            <template v-if="item.type == 'display'">
              <el-input
                v-model="data.formModel[item.prop][cIndex].value"
                :type="'textarea'"
                :autosize="item.autosize"
                :placeholder="item.placeholder"
                :readonly="true"
              ></el-input>
              <el-button
                :disabled="!data.formModel[item.prop][cIndex].value"
                @click="copy(item, cIndex)"
                >复制</el-button
              >
              <el-button
                :disabled="!data.formModel[item.prop][cIndex].value"
                @click="displayItem(item, cIndex)"
                >{{ data.displayState[item.prop] ? '显示' : '隐藏' }}</el-button
              >
            </template>
            <template v-else>
              <el-input
                v-model="data.formModel[item.prop][cIndex].value"
                :type="item.type || 'textarea'"
                :autosize="item.autosize"
                :placeholder="item.placeholder"
                @blur="inputBlur(item, cIndex)"
                @focus="inputFocus(item, cIndex)"
              ></el-input>
              <el-button v-if="cIndex > 0" @click="removeAItem(item, cIndex)">删除</el-button>
            </template>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item :key="index" :prop="item.prop" :label="item.label">
            <el-input-number
              v-if="item.type == 'number'"
              v-model="data.formModel[item.prop]"
              controls-position="right"
              :placeholder="item.placeholder"
              :min="item.min || 0"
              :max="item.max || undefined"
              :step-strictly="true"
            ></el-input-number>
            <template v-else-if="item.type == 'display'">
              <el-input
                v-model="data.formModel[item.prop]"
                :type="'textarea'"
                :autosize="item.autosize"
                :placeholder="item.placeholder"
                :readonly="true"
              ></el-input>
              <el-button :disabled="!data.formModel[item.prop]" @click="copy(item)">复制</el-button>
              <el-button :disabled="!data.formModel[item.prop]" @click="displayItem(item)">{{
                data.displayState[item.prop] ? '显示' : '隐藏'
              }}</el-button>
            </template>
            <el-select
              v-else-if="item.type == 'select'"
              v-model="data.formModel[item.prop]"
              :placeholder="item.placeholder"
            >
              <el-option
                v-for="(oItem, oIndex) in item.options"
                :key="oIndex"
                :label="oItem.label"
                :value="oItem.value"
              ></el-option>
            </el-select>
            <el-input
              v-else
              v-model="data.formModel[item.prop]"
              :type="item.type || 'textarea'"
              :autosize="item.autosize"
              :placeholder="item.placeholder"
              @blur="inputBlur(item)"
              @focus="inputFocus(item)"
            ></el-input>
          </el-form-item>
        </template>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-for="(item, index) in data.btns"
        :key="index"
        :type="item.type || 'default'"
        :loading="item.isLoading"
        @click="item.click($refs.inputForm, handleCancel, getModel, item, data)"
        >{{ item.text }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { copyText } from '@/utils/copy'
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CallTestDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      data: {},
      dialogVisible: false,
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.data = data
      this.data.securityCache = data.securityCache || {}
      this.data.displayState = data.displayState || {}
      this.dialogVisible = true
    },
    inputBlur(item, index) {
      if (item.secret) {
        if (item.isArray) {
          if (this.data.formModel[item.prop][index].value) {
            this.data.securityCache[`${item.prop}#${index}`] = this.data.formModel[item.prop][
              index
            ].value
            this.data.formModel[item.prop][index].value = '********'
          }
        } else {
          if (this.data.formModel[item.prop]) {
            this.data.securityCache[item.prop] = this.data.formModel[item.prop]
            this.data.formModel[item.prop] = '********'
          }
        }
      }
    },
    inputFocus(item, index) {
      if (item.secret) {
        if (item.isArray) {
          if (this.data.securityCache[`${item.prop}#${index}`]) {
            this.data.formModel[item.prop][index].value = this.data.securityCache[
              `${item.prop}#${index}`
            ]
            this.data.securityCache[`${item.prop}#${index}`] = undefined
          }
        } else {
          if (this.data.securityCache[item.prop]) {
            this.data.formModel[item.prop] = this.data.securityCache[item.prop]
            this.data.securityCache[item.prop] = undefined
          }
        }
      }
    },
    displayItem(item) {
      if (item.isArray) {
        this.data.displayState[`${item.prop}#${index}`] = !this.data.displayState[
          `${item.prop}#${index}`
        ]
        if (this.data.displayState[`${item.prop}#${index}`]) {
          if (this.data.formModel[item.prop][index].value) {
            this.data.securityCache[`${item.prop}#${index}`] = this.data.formModel[item.prop][
              index
            ].value
            this.data.formModel[item.prop][index].value = '********'
          }
        } else {
          if (this.data.securityCache[`${item.prop}#${index}`]) {
            this.data.formModel[item.prop][index].value = this.data.securityCache[
              `${item.prop}#${index}`
            ]
            this.data.securityCache[`${item.prop}#${index}`] = undefined
          }
        }
      } else {
        this.data.displayState[item.prop] = !this.data.displayState[item.prop]
        if (this.data.displayState[item.prop]) {
          if (this.data.formModel[item.prop]) {
            this.data.securityCache[item.prop] = this.data.formModel[item.prop]
            this.data.formModel[item.prop] = '********'
          }
        } else {
          if (this.data.securityCache[item.prop]) {
            this.data.formModel[item.prop] = this.data.securityCache[item.prop]
            this.data.securityCache[item.prop] = undefined
          }
        }
      }
    },
    copy(item) {
      if (item.isArray) {
        if (this.data.displayState[`${item.prop}#${index}`]) {
          copyText(this.data.securityCache[`${item.prop}#${index}`])
        } else {
          copyText(this.data.formModel[item.prop][index].value)
        }
      } else {
        if (this.data.displayState[item.prop]) {
          copyText(this.data.securityCache[item.prop])
        } else {
          copyText(this.data.formModel[item.prop])
        }
      }
      this.$message.success('复制成功!')
    },
    removeAItem(item, index) {
      if (index !== -1) {
        this.data.formModel[item.prop].splice(index, 1)
        if (item.isArray) {
          delete this.data.securityCache[`${item.prop}#${index}`]
        }
      }
    },
    getModel() {
      let r = {}
      for (let i = 0; i < this.data.formItems.length; i++) {
        let item = this.data.formItems[i]
        if (item.secret) {
          if (item.isArray) {
            r[item.prop] = []
            for (let j = 0; j < this.data.formModel[item.prop].length; j++) {
              let aItem = this.data.securityCache[`${item.prop}#${j}`]
              r[item.prop].push(aItem)
            }
          } else {
            r[item.prop] = this.data.securityCache[item.prop]
          }
        } else if (this.data.displayState && this.data.displayState[item.prop]) {
          r[item.prop] = this.data.securityCache[item.prop]
        } else {
          if (item.isArray) {
            r[item.prop] = []
            for (let j = 0; j < this.data.formModel[item.prop].length; j++) {
              let aItem = this.data.formModel[item.prop][j]
              r[item.prop].push(aItem.value)
            }
          } else {
            r[item.prop] = this.data.formModel[item.prop]
          }
        }
      }
      return r
    }
  }
}
</script>

<style scoped lang="scss">
.excellent-capabilities-call-test-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-form-item {
      .el-select {
        width: 100%;
      }

      /deep/ .el-form-item__content {
        display: flex;

        > :not(:first-child) {
          margin-left: var(--base-size-8);
        }
      }
    }
  }
}
</style>
